<div class="sidebar-user-root" [class.sidebar-user-root-collapsed]="collapsed">
  @if (!collapsed) {
    <div class="sidebar-user-card motion-safe-transition">
      <div class="sidebar-user-identity">
        <p-avatar
          [label]="userInitials"
          shape="circle"
          size="normal"
        />
        <div class="sidebar-user-copy">
          <span class="sidebar-user-name">{{ username }}</span>
          <span class="sidebar-user-role">{{ userRole }}</span>
        </div>
      </div>

      <button
        type="button"
        pRipple
        class="sidebar-user-logout motion-safe-transition"
        [pTooltip]="logoutInProgress ? 'Trwa wylogowywanie...' : 'Wyloguj się'"
        tooltipPosition="top"
        [attr.aria-label]="logoutInProgress ? 'Trwa wylogowywanie' : 'Wyloguj się'"
        [attr.aria-busy]="logoutInProgress"
        [disabled]="logoutInProgress"
        (click)="logoutRequested.emit()"
      >
        <app-sidebar-icon icon="pi pi-sign-out" />
      </button>
    </div>

    <div class="sidebar-user-meta">
      <div>
        FE: v0.1.3 |
        @if (backendVersionLoading) {
          <span>BE: ładowanie...</span>
        } @else if (backendVersionError) {
          <span
            class="sidebar-user-version-error"
            [pTooltip]="backendVersionError"
            tooltipPosition="top"
          >
            BE: niedostępna
          </span>
        } @else {
          <span>BE: {{ backendVersion }}</span>
        }
      </div>
      <div>© {{ currentYear }} PD</div>
    </div>

    @if (logoutError) {
      <p class="sidebar-user-error" role="alert">
        {{ logoutError }}
      </p>
    }
  } @else {
    <div class="sidebar-user-collapsed-wrap">
      <button
        type="button"
        class="sidebar-user-collapsed group relative"
        [pTooltip]="collapsedLogoutTooltip"
        tooltipPosition="right"
        [attr.aria-label]="logoutInProgress ? 'Trwa wylogowywanie' : 'Wyloguj się'"
        [attr.aria-busy]="logoutInProgress"
        [disabled]="logoutInProgress"
        (click)="logoutRequested.emit()"
      >
        <p-avatar
          [label]="userInitials"
          shape="circle"
          size="normal"
        />
        <div class="motion-safe-transition absolute inset-0 flex items-center justify-center rounded-full bg-red-500/90 text-[var(--p-surface-0)] opacity-0 group-hover:opacity-100">
          <app-sidebar-icon icon="pi pi-sign-out" />
        </div>
      </button>

      @if (logoutError) {
        <p
          class="sidebar-user-error sidebar-user-error-collapsed"
          role="alert"
          [pTooltip]="logoutError"
          tooltipPosition="right"
        >
          Błąd wylogowania
        </p>
      }
    </div>
  }
</div>
